import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn";

export default class DetailColumns {
  static getColumns() {
    return [
      DetailColumns.COLUMN_NAME(),
      DetailColumns.COLUMN_VALUE(),
    ]
  }

  static COLUMN_NAME() {
    return new StringColumn({
      key: 'name',
      align: 'left',
      text: ''
    })
  }

  static COLUMN_VALUE() {
    return new StringColumn({
      key: 'value',
      text: '',
      weight: 2
    })
  }
}
